import * as types from './types';
import _ from 'lodash';

const INITIAL_STATE = {
  fetchError: '',
  fetching: false,
  sites: [],
  teachers: [],
  report: undefined,
  grades: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.ID_CARDS_FETCH_ERROR:
      return { ...state, fetchError: payload };

    case types.ID_CARDS_FETCHING:
      return { ...state, fetching: payload };

    case types.ID_CARDS_GET_DATA:
      let teachers = payload.teachers.map(teacher => {
        return teacher.Teacher;
      });

      teachers = _.sortBy(_.uniqBy(teachers));

      teachers.unshift('ALL');

      return { ...state, teachers };

    case types.ID_CARDS_FETCH_GRADES:
      return { ...state, grades: payload };

    case types.ID_CARDS_GET_REPORT:
      return { ...state, report: payload };

    case types.ID_CARDS_CLEAR_REPORT:
      return {
        ...state,
        report: undefined,
      };

    case types.ID_CARDS_CLEAR_ERRORS:
      return {
        ...state,
        fetchError: '',
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/idcards/state/idcards/reducer.js